module.exports = __webpack_public_path__ + "media/images/application/icons/icon-share-f545d3129d4f2b3e59545f5092e26513.svg";